// extracted by mini-css-extract-plugin
export default {"root":"styles_root__FsrUT","container":"styles_container__BWlij","text":"styles_text__QCbyV","image":"styles_image__4AGf5"};